<template>
  <div id="pProject" :class="pageClass">
    <Nav type="transparent" />
    <span class="pageTitle" v-html="pageTitle"></span>
    <div style="height: 1px;"></div>
    <div class="tabBar">
      <router-link to="/Project/1" :class="{ active: $route.params.type == 1 }"
        >皮肤管理</router-link
      >
      <router-link to="/Project/2" :class="{ active: $route.params.type == 2 }"
        >头皮管理</router-link
      >
      <router-link to="/Project/3" :class="{ active: $route.params.type == 3 }"
        >身体智能管理</router-link
      >
      <!-- <router-link to="/Project/4" :class="{ active: $route.params.type == 4 }">持久妆</router-link> -->
    </div>
    <div class="tabContent clearfix">
      <div
        v-for="(item, index) in list"
        :key="index"
        @mouseenter="pcHover(index)"
        @mouseleave="pcHoverOut"
        @click="itemClick(index, item)"
        :class="{ hover: itemActive == index }"
      >
        <div class="imgBox" :class="{ hasThumb: item.thumbHover }">
          <img :src="require(`@/assets/${item.thumb}`)" alt />
          <i
            v-if="item.thumbHover"
            :style="{ 'background-image': `url(${require(`@/assets/${item.thumbHover}`)})` }"
          ></i>
          <!-- <span>快速浏览</span> -->
        </div>
        <p class="proTit" v-html="item.name"></p>
        <p class="proText" v-html="item.title"></p>
        <!-- <router-link :to="`/ProjectDetail/${$route.params.type}/${item.id}`"></router-link> -->
        <!-- <a
          href="javascript:;"
          @click="goToDetial(`/ProjectDetail/${$route.params.type}/${item.id}`)"
        ></a>-->
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import data from "@/utils/projectData.js";
export default {
  name: "pProject",
  data() {
    return {
      active: 1,
      list: [],
      pageClass: "",
      pageTitle: "",
      isIpad: false,
      itemActive: -1,
    };
  },
  components: {
    Nav,
  },
  computed: {},
  watch: {
    "$route.params.type"(t) {
      this.getData();
    },
  },
  methods: {
    getData() {
      switch (this.$route.params.type) {
        case "1":
          this.list = data.skin.data;
          this.pageClass = data.skin.pageClass;
          this.pageTitle = data.skin.pageTitle;
          break;
        case "2":
          this.list = data.head.data;
          this.pageClass = data.head.pageClass;
          this.pageTitle = data.head.pageTitle;
          break;
        case "3":
          this.list = data.body.data;
          this.pageClass = data.body.pageClass;
          this.pageTitle = data.body.pageTitle;
          break;
        case "4":
          this.list = data.face.data;
          this.pageClass = data.face.pageClass;
          this.pageTitle = data.face.pageTitle;
          break;
        default:
          this.list = data.skin.data;
          this.pageClass = data.skin.pageClass;
          this.pageTitle = data.skin.pageTitle;
      }
    },
    checkIpad() {
      if (
        (screen.width == 1366 && screen.height == 1024) ||
        (screen.width == 1024 && screen.height == 1366) ||
        (screen.width == 1194 && screen.height == 834) ||
        (screen.width == 834 && screen.height == 1194) ||
        (screen.width == 1024 && screen.height == 768) ||
        (screen.width == 768 && screen.height == 1024)
      ) {
        this.isIpad = true;
      } else {
        this.isIpad = false;
      }
      // alert(screen.width + " " + screen.height);
      // alert(this.isIpad);
    },
    itemClick(i, item) {
      // if (!this.isIpad) return;
      // this.itemActive = i;
      if (this.isIpad && this.itemActive != i) {
        this.itemActive = i;
        return;
      }
      this.goToDetial(`/ProjectDetail/${this.$route.params.type}/${item.id}`);
    },
    pcHover(i) {
      if (this.isIpad) return;
      this.itemActive = i;
    },
    pcHoverOut() {
      this.itemActive = -1;
    },
    goToDetial(path) {
      this.$router.push(path);
    },
  },
  mounted() {
    this.getData();
    this.checkIpad();
    window.addEventListener("resize", this.checkIpad, true);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkIpad, true);
  },
};
</script>

<style lang="scss" scoped>
#pProject {
  padding: 350px 0 0;
  background: url(../assets/pProject-banner.jpg) top/auto 350px no-repeat;
  &.project1 {
    background-image: url(../assets/pProject-banner.jpg);
  }
  &.project2 {
    background-image: url(../assets/pProject-banner2.jpg);
  }
  &.project3 {
    background-image: url(../assets/pProject-banner3.jpg);
  }
  &.project4 {
    background-image: url(../assets/pProject-banner4.jpg);
  }

  .tabBar {
    margin: 8px 0 0;
    // padding: 24px 0;
    text-align: center;
    border-bottom: 1px solid #f2f2f2;
    > a {
      position: relative;
      display: inline-block;
      margin: 0 36px;
      font-size: 18px;
      line-height: 66px;
      color: #a4a4a4;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: -2px;
        width: 100%;
        border-bottom: 1px solid #000;
        opacity: 0;
        transition: all 0.5s;
        transform: scale(0.4);
      }
      &.active,
      &:hover {
        font-weight: 500;
        color: #313131;
      }
      &.active::after,
      &:hover::after {
        opacity: 1;
        transform: scale(1.2);
      }
    }
  }
  .tabContent {
    margin: 90px auto 40px;
    width: 90%;
    max-width: 1200px;

    > div {
      position: relative;
      float: left;
      margin: 0 2% 100px;
      // padding: 8px 8px 38px;
      width: 21%;
      border: 1px solid transparent;

      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: -20px;
        width: 100%;
        border-bottom: 1px solid #000;
        opacity: 0;
        transition: all 0.5s;
        transform: scale(0.4);
      }
      &.hover {
        color: #313131;
        fill: #313131;

        > a {
          display: block;
        }

        .imgBox.hasThumb {
          span,
          i {
            opacity: 1;
          }
        }
      }
      &.hover::after {
        opacity: 1;
        transform: scale(1);
      }

      > a {
        display: none;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }

      .imgBox {
        position: relative;
        img {
          display: block;
          width: 100%;
        }
        i {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: left/100% 100% no-repeat;
          opacity: 0;
          transition: all 0.5s;
        }
        span {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 48px;
          font-size: 18px;
          line-height: 48px;
          color: #313131;
          text-align: center;
          background: rgba(255, 255, 255, 0.6);
          opacity: 0;
          transition: all 0.5s;
          &:hover {
            font-weight: 400;
          }
        }
        // &:hover span {
        //   opacity: 1;
        // }
      }
      // @media (max-width: 1024px) {
      //     margin: 0 1% 100px;
      //     width: 31.33%;
      // }
    }
    // @media(width: 1024px){
    //     width: 980px;
    //     > a {
    //         margin: 0 15px 100px;
    //         width: 222px;
    //     }
    // }
  }
  .proTit {
    margin-top: 12px;
    font-size: 14px;
    line-height: 20px;
    color: #313131;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .proText {
    margin-top: 4px;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
    color: #313131;
    height: 52px;
    // letter-spacing: -1px;
  }
}
</style>
